(function(){
  'use strict';
  function init(){
    var bar=document.querySelector('[data-nav]'); if(!bar) return;
    var items=bar.querySelectorAll('details.nav-item');
    var hover=window.matchMedia('(hover: hover) and (min-width: 900px)');
    function closeAll(except){items.forEach(function(d){if(d!==except) d.removeAttribute('open');});}
    items.forEach(function(d){
      d.addEventListener('toggle',function(){if(d.open) closeAll(d);});
      var t;
      d.addEventListener('mouseenter',function(){if(!hover.matches) return;clearTimeout(t);closeAll(d);d.setAttribute('open','');});
      d.addEventListener('mouseleave',function(){if(!hover.matches) return;t=setTimeout(function(){d.removeAttribute('open');},180);});
      var mega=d.querySelector('.mega');
      if(mega){
        mega.addEventListener('mouseenter',function(){clearTimeout(t);});
      }
      // position fixed panels on small screens directly under the bar
      d.addEventListener('toggle',function(){
        if(d.open && mega && window.matchMedia('(max-width: 720px)').matches){
          mega.style.top=bar.getBoundingClientRect().bottom+'px';
        } else if(mega){ mega.style.top=''; }
      });
    });
    document.addEventListener('click',function(e){if(!bar.contains(e.target)) closeAll(null);});
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){var open=bar.querySelector('details.nav-item[open]');if(open){open.removeAttribute('open');open.querySelector('summary').focus();}}
    });
    window.addEventListener('scroll',function(){if(window.matchMedia('(max-width: 720px)').matches) closeAll(null);},{passive:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
